import { BaseDetail } from 'App/Component/Bases'
import fields from 'App/Screens/Job/ExtraChargeSizes/fields'

class PageAdd extends BaseDetail {
  title = 'Extra Charge Size'
  urlData = 'module-merchant-extraChargeSize'
  fields = fields
  state = {
    isCheckingPermission: false,
    isAccessAllowed: true
  }
}

export default PageAdd